const eventDays = [23, 24, 25]; //These are the days of the month in order of the event from first to last day
export default {
	DAILY_COURSE_SELECT_STEP: 1,
	// DAILY_ADDON_SELECT_STEP: 2,
	GUEST_ADDON_STEP: 2,
	GROUP_ACTIVITY_SELECT_STEP: 3,
	GOLF_INFO_STEP: 4,
	PICKLE_BALL_INFO_STEP: 5,
	ATTENDANT_INFO_STEP: 6,
	REGISTRATION_REVIEW_STEP: 7,
	VID_MEMBERSHIP: process.env.VID_MEMBERSHIP,
	GOLF_VID: process.env.GOLF_VID,
	SOUND_BATH_VID: process.env.SOUND_BATH_VID,
	PICKLE_BALL_VID: process.env.PICKLE_BALL_VID,
	FI25_EVENT_ID: process.env.FI25_EVENT_ID,
	FI25_GUEST_VID: process.env.FI25_GUEST_VID,
	FI25_VANGUARD_VID: process.env.FI25_VANGUARD_VID,
	GROUP_ACTIVITY_DAY: 2,
	DAY_MAP: eventDays.reduce((acc, d, i) => ({ ...acc, [i + 1]: d }), {}),
	// 1: 24,
	// 2: 25,
	// 3: 26,
	// //  4: 29
	// },
	EVENT_DAY_MAP: eventDays.reduce((acc, d, i) => ({ ...acc, [d]: i + 1 }), {}),

	// EVENT_DAY_MAP: {
	// 	24: 1,
	// 	25: 2,
	// 	26: 3,
	// 	//  29: 4
	// },
	WEEK_DAY_MAP: {
		1: "Thursday",
		2: "Friday",
		3: "Saturday",
		// 4: "Sunday"
	},
	FALL_YEAR: "2025",
	FALL_DATES: "October 23-25",
	NAME_SPLIT: ": 2025 Fall Institute",
	MEMBERSHIP_COST: 349,
	EARLY_BIRD_DEADLINE: "7/15",
	ADVANCED_DEADLINE: "9/15",
	// EARLY_BIRD_DEADLINE:'7/15',
};
